module.exports = __webpack_public_path__ + "static/media/lightning-icon.08252403.svg";